










































































import { defineComponent, PropType, ref } from '@nuxtjs/composition-api';
import SvgImage from '~/components/General/SvgImage.vue';

export default defineComponent({
  name: 'CreditCardListDesktop',
  components: {
    SvgImage,
  },
  props: {
    paymentCards: {
      type: Array as PropType<any[]>,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: true,
    },
    deletePaymentCard: {
      type: Function as PropType<(id: string) => void>,
      required: true,
    },
    decrypt: {
      type: Function as PropType<(value: string, cvi: string) => string>,
      required: true,
    },
    censoredText: {
      type: Function as PropType<(text: string) => string>,
      required: true,
    },
    handleCardClick: {
      type: Function as PropType<(paymentCard: any, index: number) => void>,
      required: true,
    },
  },
  setup() {
    const menuIndex = ref<number | null>(null);

    const toggleMenu = (index: number) => {
      menuIndex.value = menuIndex.value === index ? null : index;
    };

    return {
      menuIndex,
      toggleMenu,

    };
  },
});
